// src/data/abilities.ts — Habilidades pasivas modulares Fase 4
export type AbilityEffect = (ctx: AbilityContext)=> void;
export type AbilityContext = {
  owner: 'player'|'enemy';
  stat?: 'atk'|'def'|'spd';
  weather?: string;
  terrain?: string;
  damage?: number;
};

export type Ability = {
  id: string;
  name: string;
  description: string;
  apply: (unit:any, ctx:AbilityContext)=> any; // recibe unit y retorna modificado o efecto
};

export const ABILITIES: Record<string, Ability> = {
  fotosintesis: {
    id:'fotosintesis', name:'Fotosíntesis', description:'Cura 8% cada turno en terreno vegetal.',
    apply: (unit, ctx)=> { if(ctx.terrain==='vegetal' && unit.element==='terra') return { heal: Math.floor(unit.maxHp*0.08) }; return null; }
  },
  sobrecarga: {
    id:'sobrecarga', name:'Sobrecarga', description:'+15% daño en tormenta si es astra.',
    apply: (unit, ctx)=> { if(ctx.weather==='tormenta' && unit.element==='astra') return { damageMult: 1.15 }; return null; }
  },
  velo_fluido: {
    id:'velo_fluido', name:'Velo Fluido', description:'+20% defensa en lluvia si es aqua.',
    apply: (unit, ctx)=> { if(ctx.weather==='lluvia' && unit.element==='aqua') return { defMult: 1.2 }; return null; }
  },
  brasa_persistente: {
    id:'brasa_persistente', name:'Brasa Persistente', description:'Brasa ignis dura 1 turno más.',
    apply: ()=> null
  },
  manto_nocturno: {
    id:'manto_nocturno', name:'Manto Nocturno', description:'Esquiva +15% de noche con niebla si es umbra.',
    apply: (unit, ctx)=> { if(unit.element==='umbra') return { evasion: 0.15 }; return null; }
  },
  nucleo_estable: {
    id:'nucleo_estable', name:'Núcleo Estable', description:'Resiste un golpe letal con 1 PS 1 vez por combate.',
    apply: ()=> null
  },
  rafaga: {
    id:'rafaga', name:'Ráfaga', description:'+10% velocidad si HP <50%.',
    apply: (unit)=> { if(unit.hp < unit.maxHp*0.5) return { spdMult: 1.1 }; return null; }
  },
};

export function getAbility(id:string): Ability | undefined { return ABILITIES[id]; }
